module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=SM - San Marino.c455d5a0.svg";